// extracted by mini-css-extract-plugin
export default {"page":"sO","wrapper":"tO","text":"uO","icons":"vO","icon":"wO","icon_text":"xO","carousel_wrapper":"yO","slide":"zO","image":"AO","arrows":"BO","prev":"CO","modal_root":"EO","x_mark":"FO","modal":"GO","images":"HO","main_image":"IO","name":"JO"};
    if(module.hot) {
      // 1737143662623
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  